export default {
  back: "Back",
  error: "Error",
  votes: "Votes",
  blockchain: "Blockchain",
  logout: "Logout",
  logoutConfirmTitle: "Log out?",
  logoutConfirmMessage: "Your current session will be closed.",
  confirm: "Confirm",
  view: "View",
  loading: "Loading...",
  cancel: "Cancel",
  save: "Save",
  close: "Close",
}
